import React from 'react';
import { IconWrapper, Info, SuggestedListItemWrapper } from './styled';
import { SmallText } from 'ds/components/typography';
import { NeighborhoodCardLabels } from 'store/sagas/apiService/types';
import { getLabel } from './helper';
import { useLocale } from 'locale';
import { NeighborhoodInsightChip } from '../InsightChip/NeighborhoodInsightChip';
import CityIcon from 'assets/svg/city-bw.svg';

export const SimilarHoodItem: React.FC<{ onClick?: () => void; name: string; labels: NeighborhoodCardLabels }> = ({
  onClick,
  name,
  labels,
}) => {
  const { t } = useLocale();

  const getChip = (labelList: NeighborhoodCardLabels) => {
    const label = getLabel(labelList, t);
    return label ? <NeighborhoodInsightChip {...label} /> : null;
  };

  return (
    <SuggestedListItemWrapper onClick={onClick}>
      <IconWrapper>
        <CityIcon width={24} height={24} />
      </IconWrapper>
      <Info>
        <SmallText weight="bold">{name}</SmallText>
        {getChip(labels)}
      </Info>
    </SuggestedListItemWrapper>
  );
};
